import { defineMessages } from 'react-intl';

export const powerWithSkinBonus = (
  power: string,
  skinEdition: Nullable<{ bonus: Nullable<number> }>
): number => {
  const skinBonus = skinEdition?.bonus ? skinEdition.bonus - 1 : 0;
  return (Number(power) || 1) + skinBonus;
};

export const bonusMessages = defineMessages({
  captain: {
    defaultMessage: 'Captain bonus',
  },
  levelBonus: {
    defaultMessage: 'XP bonus',
  },
  scarcity: {
    defaultMessage: 'Scarcity bonus',
  },
  transferMalus: {
    defaultMessage: 'Non transferrable XP',
  },
  collection: {
    defaultMessage: 'Collection bonus',
  },
  season: {
    defaultMessage: 'Season bonus',
  },
  club: {
    defaultMessage: 'Club bonus',
  },
  nationality: {
    defaultMessage: 'Nationality bonus',
  },
  position: {
    defaultMessage: 'Position bonus',
  },
  specialEdition: {
    defaultMessage: 'Special Edition bonus',
  },
});
